/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VerifyRouteImport } from './routes/verify'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AcceptInvitationTokenRouteImport } from './routes/accept-invitation.$token'
import { Route as AuthedTeamRouteImport } from './routes/_authed.team'
import { Route as AuthedSettingsRouteImport } from './routes/_authed.settings'
import { Route as AuthedReportsRouteImport } from './routes/_authed.reports'
import { Route as AuthedProfileRouteImport } from './routes/_authed.profile'
import { Route as AuthedPaymentsRouteImport } from './routes/_authed.payments'
import { Route as AuthedMissionsRouteImport } from './routes/_authed.missions'
import { Route as AuthedMapRouteImport } from './routes/_authed.map'
import { Route as AuthedMaintenanceRouteImport } from './routes/_authed.maintenance'
import { Route as AuthedInvoicesRouteImport } from './routes/_authed.invoices'
import { Route as AuthedGeofencesRouteImport } from './routes/_authed.geofences'
import { Route as AuthedFuelRouteImport } from './routes/_authed.fuel'
import { Route as AuthedFleetRouteImport } from './routes/_authed.fleet'
import { Route as AuthedDriversRouteImport } from './routes/_authed.drivers'
import { Route as AuthedDashboardRouteImport } from './routes/_authed.dashboard'
import { Route as AuthedClientsRouteImport } from './routes/_authed.clients'
import { Route as AuthedAlertsRouteImport } from './routes/_authed.alerts'
import { Route as AuthedMissionsNewRouteImport } from './routes/_authed.missions.new'
import { Route as AuthedMissionsIdRouteImport } from './routes/_authed.missions.$id'
import { Route as AuthedInvoicesIdRouteImport } from './routes/_authed.invoices.$id'
import { Route as AuthedFleetNewRouteImport } from './routes/_authed.fleet.new'
import { Route as AuthedFleetIdRouteImport } from './routes/_authed.fleet.$id'
import { Route as AuthedDriversNewRouteImport } from './routes/_authed.drivers.new'
import { Route as AuthedDriversIdRouteImport } from './routes/_authed.drivers.$id'
import { Route as AuthedClientsNewRouteImport } from './routes/_authed.clients.new'
import { Route as AuthedClientsIdRouteImport } from './routes/_authed.clients.$id'

const VerifyRoute = VerifyRouteImport.update({
  id: '/verify',
  path: '/verify',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptInvitationTokenRoute = AcceptInvitationTokenRouteImport.update({
  id: '/accept-invitation/$token',
  path: '/accept-invitation/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedTeamRoute = AuthedTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSettingsRoute = AuthedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedReportsRoute = AuthedReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedProfileRoute = AuthedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPaymentsRoute = AuthedPaymentsRouteImport.update({
  id: '/payments',
  path: '/payments',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMissionsRoute = AuthedMissionsRouteImport.update({
  id: '/missions',
  path: '/missions',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMapRoute = AuthedMapRouteImport.update({
  id: '/map',
  path: '/map',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMaintenanceRoute = AuthedMaintenanceRouteImport.update({
  id: '/maintenance',
  path: '/maintenance',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedInvoicesRoute = AuthedInvoicesRouteImport.update({
  id: '/invoices',
  path: '/invoices',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedGeofencesRoute = AuthedGeofencesRouteImport.update({
  id: '/geofences',
  path: '/geofences',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedFuelRoute = AuthedFuelRouteImport.update({
  id: '/fuel',
  path: '/fuel',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedFleetRoute = AuthedFleetRouteImport.update({
  id: '/fleet',
  path: '/fleet',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDriversRoute = AuthedDriversRouteImport.update({
  id: '/drivers',
  path: '/drivers',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedDashboardRoute = AuthedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedClientsRoute = AuthedClientsRouteImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAlertsRoute = AuthedAlertsRouteImport.update({
  id: '/alerts',
  path: '/alerts',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedMissionsNewRoute = AuthedMissionsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthedMissionsRoute,
} as any)
const AuthedMissionsIdRoute = AuthedMissionsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuthedMissionsRoute,
} as any)
const AuthedInvoicesIdRoute = AuthedInvoicesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuthedInvoicesRoute,
} as any)
const AuthedFleetNewRoute = AuthedFleetNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthedFleetRoute,
} as any)
const AuthedFleetIdRoute = AuthedFleetIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuthedFleetRoute,
} as any)
const AuthedDriversNewRoute = AuthedDriversNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthedDriversRoute,
} as any)
const AuthedDriversIdRoute = AuthedDriversIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuthedDriversRoute,
} as any)
const AuthedClientsNewRoute = AuthedClientsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AuthedClientsRoute,
} as any)
const AuthedClientsIdRoute = AuthedClientsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuthedClientsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/verify': typeof VerifyRoute
  '/alerts': typeof AuthedAlertsRoute
  '/clients': typeof AuthedClientsRouteWithChildren
  '/dashboard': typeof AuthedDashboardRoute
  '/drivers': typeof AuthedDriversRouteWithChildren
  '/fleet': typeof AuthedFleetRouteWithChildren
  '/fuel': typeof AuthedFuelRoute
  '/geofences': typeof AuthedGeofencesRoute
  '/invoices': typeof AuthedInvoicesRouteWithChildren
  '/maintenance': typeof AuthedMaintenanceRoute
  '/map': typeof AuthedMapRoute
  '/missions': typeof AuthedMissionsRouteWithChildren
  '/payments': typeof AuthedPaymentsRoute
  '/profile': typeof AuthedProfileRoute
  '/reports': typeof AuthedReportsRoute
  '/settings': typeof AuthedSettingsRoute
  '/team': typeof AuthedTeamRoute
  '/accept-invitation/$token': typeof AcceptInvitationTokenRoute
  '/clients/$id': typeof AuthedClientsIdRoute
  '/clients/new': typeof AuthedClientsNewRoute
  '/drivers/$id': typeof AuthedDriversIdRoute
  '/drivers/new': typeof AuthedDriversNewRoute
  '/fleet/$id': typeof AuthedFleetIdRoute
  '/fleet/new': typeof AuthedFleetNewRoute
  '/invoices/$id': typeof AuthedInvoicesIdRoute
  '/missions/$id': typeof AuthedMissionsIdRoute
  '/missions/new': typeof AuthedMissionsNewRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/verify': typeof VerifyRoute
  '/alerts': typeof AuthedAlertsRoute
  '/clients': typeof AuthedClientsRouteWithChildren
  '/dashboard': typeof AuthedDashboardRoute
  '/drivers': typeof AuthedDriversRouteWithChildren
  '/fleet': typeof AuthedFleetRouteWithChildren
  '/fuel': typeof AuthedFuelRoute
  '/geofences': typeof AuthedGeofencesRoute
  '/invoices': typeof AuthedInvoicesRouteWithChildren
  '/maintenance': typeof AuthedMaintenanceRoute
  '/map': typeof AuthedMapRoute
  '/missions': typeof AuthedMissionsRouteWithChildren
  '/payments': typeof AuthedPaymentsRoute
  '/profile': typeof AuthedProfileRoute
  '/reports': typeof AuthedReportsRoute
  '/settings': typeof AuthedSettingsRoute
  '/team': typeof AuthedTeamRoute
  '/accept-invitation/$token': typeof AcceptInvitationTokenRoute
  '/clients/$id': typeof AuthedClientsIdRoute
  '/clients/new': typeof AuthedClientsNewRoute
  '/drivers/$id': typeof AuthedDriversIdRoute
  '/drivers/new': typeof AuthedDriversNewRoute
  '/fleet/$id': typeof AuthedFleetIdRoute
  '/fleet/new': typeof AuthedFleetNewRoute
  '/invoices/$id': typeof AuthedInvoicesIdRoute
  '/missions/$id': typeof AuthedMissionsIdRoute
  '/missions/new': typeof AuthedMissionsNewRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authed': typeof AuthedRouteWithChildren
  '/login': typeof LoginRoute
  '/verify': typeof VerifyRoute
  '/_authed/alerts': typeof AuthedAlertsRoute
  '/_authed/clients': typeof AuthedClientsRouteWithChildren
  '/_authed/dashboard': typeof AuthedDashboardRoute
  '/_authed/drivers': typeof AuthedDriversRouteWithChildren
  '/_authed/fleet': typeof AuthedFleetRouteWithChildren
  '/_authed/fuel': typeof AuthedFuelRoute
  '/_authed/geofences': typeof AuthedGeofencesRoute
  '/_authed/invoices': typeof AuthedInvoicesRouteWithChildren
  '/_authed/maintenance': typeof AuthedMaintenanceRoute
  '/_authed/map': typeof AuthedMapRoute
  '/_authed/missions': typeof AuthedMissionsRouteWithChildren
  '/_authed/payments': typeof AuthedPaymentsRoute
  '/_authed/profile': typeof AuthedProfileRoute
  '/_authed/reports': typeof AuthedReportsRoute
  '/_authed/settings': typeof AuthedSettingsRoute
  '/_authed/team': typeof AuthedTeamRoute
  '/accept-invitation/$token': typeof AcceptInvitationTokenRoute
  '/_authed/clients/$id': typeof AuthedClientsIdRoute
  '/_authed/clients/new': typeof AuthedClientsNewRoute
  '/_authed/drivers/$id': typeof AuthedDriversIdRoute
  '/_authed/drivers/new': typeof AuthedDriversNewRoute
  '/_authed/fleet/$id': typeof AuthedFleetIdRoute
  '/_authed/fleet/new': typeof AuthedFleetNewRoute
  '/_authed/invoices/$id': typeof AuthedInvoicesIdRoute
  '/_authed/missions/$id': typeof AuthedMissionsIdRoute
  '/_authed/missions/new': typeof AuthedMissionsNewRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/verify'
    | '/alerts'
    | '/clients'
    | '/dashboard'
    | '/drivers'
    | '/fleet'
    | '/fuel'
    | '/geofences'
    | '/invoices'
    | '/maintenance'
    | '/map'
    | '/missions'
    | '/payments'
    | '/profile'
    | '/reports'
    | '/settings'
    | '/team'
    | '/accept-invitation/$token'
    | '/clients/$id'
    | '/clients/new'
    | '/drivers/$id'
    | '/drivers/new'
    | '/fleet/$id'
    | '/fleet/new'
    | '/invoices/$id'
    | '/missions/$id'
    | '/missions/new'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/verify'
    | '/alerts'
    | '/clients'
    | '/dashboard'
    | '/drivers'
    | '/fleet'
    | '/fuel'
    | '/geofences'
    | '/invoices'
    | '/maintenance'
    | '/map'
    | '/missions'
    | '/payments'
    | '/profile'
    | '/reports'
    | '/settings'
    | '/team'
    | '/accept-invitation/$token'
    | '/clients/$id'
    | '/clients/new'
    | '/drivers/$id'
    | '/drivers/new'
    | '/fleet/$id'
    | '/fleet/new'
    | '/invoices/$id'
    | '/missions/$id'
    | '/missions/new'
  id:
    | '__root__'
    | '/'
    | '/_authed'
    | '/login'
    | '/verify'
    | '/_authed/alerts'
    | '/_authed/clients'
    | '/_authed/dashboard'
    | '/_authed/drivers'
    | '/_authed/fleet'
    | '/_authed/fuel'
    | '/_authed/geofences'
    | '/_authed/invoices'
    | '/_authed/maintenance'
    | '/_authed/map'
    | '/_authed/missions'
    | '/_authed/payments'
    | '/_authed/profile'
    | '/_authed/reports'
    | '/_authed/settings'
    | '/_authed/team'
    | '/accept-invitation/$token'
    | '/_authed/clients/$id'
    | '/_authed/clients/new'
    | '/_authed/drivers/$id'
    | '/_authed/drivers/new'
    | '/_authed/fleet/$id'
    | '/_authed/fleet/new'
    | '/_authed/invoices/$id'
    | '/_authed/missions/$id'
    | '/_authed/missions/new'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthedRoute: typeof AuthedRouteWithChildren
  LoginRoute: typeof LoginRoute
  VerifyRoute: typeof VerifyRoute
  AcceptInvitationTokenRoute: typeof AcceptInvitationTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify': {
      id: '/verify'
      path: '/verify'
      fullPath: '/verify'
      preLoaderRoute: typeof VerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accept-invitation/$token': {
      id: '/accept-invitation/$token'
      path: '/accept-invitation/$token'
      fullPath: '/accept-invitation/$token'
      preLoaderRoute: typeof AcceptInvitationTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/team': {
      id: '/_authed/team'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof AuthedTeamRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings': {
      id: '/_authed/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthedSettingsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/reports': {
      id: '/_authed/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AuthedReportsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/profile': {
      id: '/_authed/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthedProfileRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/payments': {
      id: '/_authed/payments'
      path: '/payments'
      fullPath: '/payments'
      preLoaderRoute: typeof AuthedPaymentsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/missions': {
      id: '/_authed/missions'
      path: '/missions'
      fullPath: '/missions'
      preLoaderRoute: typeof AuthedMissionsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/map': {
      id: '/_authed/map'
      path: '/map'
      fullPath: '/map'
      preLoaderRoute: typeof AuthedMapRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/maintenance': {
      id: '/_authed/maintenance'
      path: '/maintenance'
      fullPath: '/maintenance'
      preLoaderRoute: typeof AuthedMaintenanceRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/invoices': {
      id: '/_authed/invoices'
      path: '/invoices'
      fullPath: '/invoices'
      preLoaderRoute: typeof AuthedInvoicesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/geofences': {
      id: '/_authed/geofences'
      path: '/geofences'
      fullPath: '/geofences'
      preLoaderRoute: typeof AuthedGeofencesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/fuel': {
      id: '/_authed/fuel'
      path: '/fuel'
      fullPath: '/fuel'
      preLoaderRoute: typeof AuthedFuelRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/fleet': {
      id: '/_authed/fleet'
      path: '/fleet'
      fullPath: '/fleet'
      preLoaderRoute: typeof AuthedFleetRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/drivers': {
      id: '/_authed/drivers'
      path: '/drivers'
      fullPath: '/drivers'
      preLoaderRoute: typeof AuthedDriversRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/dashboard': {
      id: '/_authed/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthedDashboardRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/clients': {
      id: '/_authed/clients'
      path: '/clients'
      fullPath: '/clients'
      preLoaderRoute: typeof AuthedClientsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/alerts': {
      id: '/_authed/alerts'
      path: '/alerts'
      fullPath: '/alerts'
      preLoaderRoute: typeof AuthedAlertsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/missions/new': {
      id: '/_authed/missions/new'
      path: '/new'
      fullPath: '/missions/new'
      preLoaderRoute: typeof AuthedMissionsNewRouteImport
      parentRoute: typeof AuthedMissionsRoute
    }
    '/_authed/missions/$id': {
      id: '/_authed/missions/$id'
      path: '/$id'
      fullPath: '/missions/$id'
      preLoaderRoute: typeof AuthedMissionsIdRouteImport
      parentRoute: typeof AuthedMissionsRoute
    }
    '/_authed/invoices/$id': {
      id: '/_authed/invoices/$id'
      path: '/$id'
      fullPath: '/invoices/$id'
      preLoaderRoute: typeof AuthedInvoicesIdRouteImport
      parentRoute: typeof AuthedInvoicesRoute
    }
    '/_authed/fleet/new': {
      id: '/_authed/fleet/new'
      path: '/new'
      fullPath: '/fleet/new'
      preLoaderRoute: typeof AuthedFleetNewRouteImport
      parentRoute: typeof AuthedFleetRoute
    }
    '/_authed/fleet/$id': {
      id: '/_authed/fleet/$id'
      path: '/$id'
      fullPath: '/fleet/$id'
      preLoaderRoute: typeof AuthedFleetIdRouteImport
      parentRoute: typeof AuthedFleetRoute
    }
    '/_authed/drivers/new': {
      id: '/_authed/drivers/new'
      path: '/new'
      fullPath: '/drivers/new'
      preLoaderRoute: typeof AuthedDriversNewRouteImport
      parentRoute: typeof AuthedDriversRoute
    }
    '/_authed/drivers/$id': {
      id: '/_authed/drivers/$id'
      path: '/$id'
      fullPath: '/drivers/$id'
      preLoaderRoute: typeof AuthedDriversIdRouteImport
      parentRoute: typeof AuthedDriversRoute
    }
    '/_authed/clients/new': {
      id: '/_authed/clients/new'
      path: '/new'
      fullPath: '/clients/new'
      preLoaderRoute: typeof AuthedClientsNewRouteImport
      parentRoute: typeof AuthedClientsRoute
    }
    '/_authed/clients/$id': {
      id: '/_authed/clients/$id'
      path: '/$id'
      fullPath: '/clients/$id'
      preLoaderRoute: typeof AuthedClientsIdRouteImport
      parentRoute: typeof AuthedClientsRoute
    }
  }
}

interface AuthedClientsRouteChildren {
  AuthedClientsIdRoute: typeof AuthedClientsIdRoute
  AuthedClientsNewRoute: typeof AuthedClientsNewRoute
}

const AuthedClientsRouteChildren: AuthedClientsRouteChildren = {
  AuthedClientsIdRoute: AuthedClientsIdRoute,
  AuthedClientsNewRoute: AuthedClientsNewRoute,
}

const AuthedClientsRouteWithChildren = AuthedClientsRoute._addFileChildren(
  AuthedClientsRouteChildren,
)

interface AuthedDriversRouteChildren {
  AuthedDriversIdRoute: typeof AuthedDriversIdRoute
  AuthedDriversNewRoute: typeof AuthedDriversNewRoute
}

const AuthedDriversRouteChildren: AuthedDriversRouteChildren = {
  AuthedDriversIdRoute: AuthedDriversIdRoute,
  AuthedDriversNewRoute: AuthedDriversNewRoute,
}

const AuthedDriversRouteWithChildren = AuthedDriversRoute._addFileChildren(
  AuthedDriversRouteChildren,
)

interface AuthedFleetRouteChildren {
  AuthedFleetIdRoute: typeof AuthedFleetIdRoute
  AuthedFleetNewRoute: typeof AuthedFleetNewRoute
}

const AuthedFleetRouteChildren: AuthedFleetRouteChildren = {
  AuthedFleetIdRoute: AuthedFleetIdRoute,
  AuthedFleetNewRoute: AuthedFleetNewRoute,
}

const AuthedFleetRouteWithChildren = AuthedFleetRoute._addFileChildren(
  AuthedFleetRouteChildren,
)

interface AuthedInvoicesRouteChildren {
  AuthedInvoicesIdRoute: typeof AuthedInvoicesIdRoute
}

const AuthedInvoicesRouteChildren: AuthedInvoicesRouteChildren = {
  AuthedInvoicesIdRoute: AuthedInvoicesIdRoute,
}

const AuthedInvoicesRouteWithChildren = AuthedInvoicesRoute._addFileChildren(
  AuthedInvoicesRouteChildren,
)

interface AuthedMissionsRouteChildren {
  AuthedMissionsIdRoute: typeof AuthedMissionsIdRoute
  AuthedMissionsNewRoute: typeof AuthedMissionsNewRoute
}

const AuthedMissionsRouteChildren: AuthedMissionsRouteChildren = {
  AuthedMissionsIdRoute: AuthedMissionsIdRoute,
  AuthedMissionsNewRoute: AuthedMissionsNewRoute,
}

const AuthedMissionsRouteWithChildren = AuthedMissionsRoute._addFileChildren(
  AuthedMissionsRouteChildren,
)

interface AuthedRouteChildren {
  AuthedAlertsRoute: typeof AuthedAlertsRoute
  AuthedClientsRoute: typeof AuthedClientsRouteWithChildren
  AuthedDashboardRoute: typeof AuthedDashboardRoute
  AuthedDriversRoute: typeof AuthedDriversRouteWithChildren
  AuthedFleetRoute: typeof AuthedFleetRouteWithChildren
  AuthedFuelRoute: typeof AuthedFuelRoute
  AuthedGeofencesRoute: typeof AuthedGeofencesRoute
  AuthedInvoicesRoute: typeof AuthedInvoicesRouteWithChildren
  AuthedMaintenanceRoute: typeof AuthedMaintenanceRoute
  AuthedMapRoute: typeof AuthedMapRoute
  AuthedMissionsRoute: typeof AuthedMissionsRouteWithChildren
  AuthedPaymentsRoute: typeof AuthedPaymentsRoute
  AuthedProfileRoute: typeof AuthedProfileRoute
  AuthedReportsRoute: typeof AuthedReportsRoute
  AuthedSettingsRoute: typeof AuthedSettingsRoute
  AuthedTeamRoute: typeof AuthedTeamRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedAlertsRoute: AuthedAlertsRoute,
  AuthedClientsRoute: AuthedClientsRouteWithChildren,
  AuthedDashboardRoute: AuthedDashboardRoute,
  AuthedDriversRoute: AuthedDriversRouteWithChildren,
  AuthedFleetRoute: AuthedFleetRouteWithChildren,
  AuthedFuelRoute: AuthedFuelRoute,
  AuthedGeofencesRoute: AuthedGeofencesRoute,
  AuthedInvoicesRoute: AuthedInvoicesRouteWithChildren,
  AuthedMaintenanceRoute: AuthedMaintenanceRoute,
  AuthedMapRoute: AuthedMapRoute,
  AuthedMissionsRoute: AuthedMissionsRouteWithChildren,
  AuthedPaymentsRoute: AuthedPaymentsRoute,
  AuthedProfileRoute: AuthedProfileRoute,
  AuthedReportsRoute: AuthedReportsRoute,
  AuthedSettingsRoute: AuthedSettingsRoute,
  AuthedTeamRoute: AuthedTeamRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthedRoute: AuthedRouteWithChildren,
  LoginRoute: LoginRoute,
  VerifyRoute: VerifyRoute,
  AcceptInvitationTokenRoute: AcceptInvitationTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
